// helpers/locationApi.ts

// Fetch all states from the API
export const fetchStates = async () => {
  const response = await fetch("https://nga-states-lga.onrender.com/fetch");
  const data = await response.json();
  return data; // The API returns an array of states directly
};

// Fetch LGAs for a specific state from the API
export const fetchLGAs = async (state: string) => {
  const response = await fetch(
    `https://nga-states-lga.onrender.com/?state=${state}`
  );
  const data = await response.json();
  return data; // The API returns an array of LGAs directly
};
